import Swal from "sweetalert2";

const BASE_OPTIONS = {
  confirmButtonColor: "#F97316",
  cancelButtonColor: "#78716c",
  background: "#FFFFFF",
  customClass: {
    popup: "app-swal-popup",
    title: "app-swal-title",
    htmlContainer: "app-swal-text",
    confirmButton: "app-swal-confirm",
    cancelButton: "app-swal-cancel",
    actions: "app-swal-actions",
  },
  buttonsStyling: false,
};

const toHtmlText = (message, messageAr) => {
  const msg = String(message || "");
  if (!messageAr) return msg;
  return `${msg}<br><span class="app-swal-ar">${String(messageAr)}</span>`;
};

export const showAlert = async (
  message,
  title = "Notice",
  icon = "info",
  options = {},
) =>
  Swal.fire({
    ...BASE_OPTIONS,
    ...options,
    customClass: {
      ...BASE_OPTIONS.customClass,
      ...(options.customClass || {}),
      popup: `${BASE_OPTIONS.customClass.popup}${options.compact ? " app-swal-popup-compact" : ""} ${
        options.customClass?.popup || ""
      }`.trim(),
    },
    title,
    html: toHtmlText(message, options.messageAr),
    confirmButtonText: options.confirmText || "OK",
    icon,
  });

export const showSuccess = async (message, title = "Success") =>
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: "success",
    title: String(title || "Success"),
    text: String(message || "Action completed successfully."),
    showConfirmButton: false,
    timer: 2200,
    timerProgressBar: true,
  });

export const showError = async (message, title = "Error") =>
  showAlert(message, title, "error");

export const showConfirm = async (
  message,
  title = "Please Confirm",
  confirmText = "Yes",
  cancelText = "Cancel",
  options = {},
) => {
  const result = await Swal.fire({
    ...BASE_OPTIONS,
    ...options,
    customClass: {
      ...BASE_OPTIONS.customClass,
      ...(options.customClass || {}),
      popup: `${BASE_OPTIONS.customClass.popup}${options.compact ? " app-swal-popup-compact" : ""} ${
        options.customClass?.popup || ""
      }`.trim(),
    },
    title,
    html: toHtmlText(message, options.messageAr),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: options.cancelText || cancelText,
  });
  return result.isConfirmed;
};
